import React from 'react';
import classNames from 'classnames';
import Loader from 'src/components/Loader';
import styles from './assets/wage-create-screen.module.scss';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/WageForm';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';
import { QueryParams } from '../../../../../../types/grid';
import Router from '../../../../../../navigation/router';

export interface StateProps {
    inProgress: boolean;
    inProgressProvider: boolean;
    providers: SelectObject[];
    providerSelect?: string | number;
}

export interface DispatchProps {
    getProviders: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const WageCreateScreen: React.FunctionComponent<Props> = (props) => {
    const { inProgress, providers, providerSelect, inProgressProvider, getProviders } = props;
    React.useEffect(() => {
        getProviders({});
        // eslint-disable-next-line
    }, []);
    if (inProgress) {
        return <Loader />;
    }
    let descSalary = '';
    if (providerSelect) {
        providers.forEach((it: any) => {
            if (+it.value === +providerSelect) {
                descSalary = it.annualSalary ? `${it.annualSalary}` : '';
            }
        });
    }

    if (descSalary) {
        descSalary = `Provider gets in average $${+descSalary / 12} per month`;
    }
    return (
        <RoleLayout>
            <Breadcrumbs
                noGenerate={true}
                items={[
                    { name: 'FIXED SALARY', path: Router.generate(routes.WAGES_LIST, { param: '' }) },
                    { name: `ADD NEW`, path: '' },
                ]}
            />

            <div className={classNames(styles.wrapForm)}>
                {inProgress || inProgressProvider ? <Loader /> : null}
                <Form
                    descSalary={descSalary}
                    providers={providers}
                    providerSelect={providerSelect}
                    initialValues={{}}
                />
            </div>
        </RoleLayout>
    );
};

export default WageCreateScreen;
